import { render, staticRenderFns } from "./CmgEditAccountModal.vue?vue&type=template&id=1a6059c6&scoped=true&lang=pug"
import script from "./cmg-edit-account-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-edit-account-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgEditAccountModal.vue?vue&type=style&index=0&id=1a6059c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6059c6",
  null
  
)

export default component.exports